module.exports = __webpack_public_path__ + "img/11.44aebc11.png";